import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Outlet, useNavigate } from 'react-router-dom';

import { logout } from 'entities/Auth/sdk';

import { getToken, removeToken } from 'utils/storage';

import { URLS } from 'config/urls';

const AuthGuard = () => {
  const navigate = useNavigate();
  const token = getToken();

  useEffect(() => {
    if (!token) {
      navigate(URLS.LOGIN);
    }
  }, [navigate, token]);

  const handleOnIdle = () => {
    logout().then(() => {
      removeToken();
      navigate(URLS.LOGIN);
    });
  };

  useIdleTimer({
    timeout: 10 * 60 * 1000,
    onIdle: handleOnIdle
  });

  return <Outlet />;
};

export default AuthGuard;
